import React, { useCallback, useEffect, useState } from 'react'

import { SavedUser } from 'modules/auth/components'
import { AuthPageTemplate } from 'modules/auth/templates'
import { useNavigate } from 'react-router-dom'
import loginBg from 'shared/assets/backgrounds/login-bg.webp'
import { LocalStorageKey } from 'shared/constants/localStorage'
import { lsGetItem, lsSetItem } from 'shared/utils/local-storage'

import styles from './SelectUserPage.module.scss'

export const SelectUserPage = () => {
  const navigate = useNavigate()

  const [users, setUsers] = useState(() => {
    const storedUsers = lsGetItem(LocalStorageKey.SELECTABLE_USERS) ?? []
    const seenEmails = new Set<string>()
    const uniqueUsers = storedUsers.filter(user => {
      const emailLower = user.email.toLowerCase()
      if (seenEmails.has(emailLower)) {
        return false
      }
      seenEmails.add(emailLower)
      return true
    })
    if (uniqueUsers.length !== storedUsers.length) {
      lsSetItem(LocalStorageKey.SELECTABLE_USERS, uniqueUsers)
    }
    return uniqueUsers
  })

  const handleRemoveUser = useCallback((userId: string) => {
    setUsers(prevUsers => {
      const updatedUsers = prevUsers.filter(user => user.id !== userId)
      lsSetItem(LocalStorageKey.SELECTABLE_USERS, updatedUsers)
      return updatedUsers
    })
  }, [])

  useEffect(() => {
    if (users.length === 0) {
      // not history.push because we want to reload the page
      // for auth template to get the new saved users array
      window.open('/login', '_self')
    }
  }, [users, navigate])

  return (
    <AuthPageTemplate backgroundImageUrl={loginBg}>
      <div className={styles.selectUserPage}>
        <div className={styles.users}>
          {users.map(user => (
            <div key={user.id} className={styles.userWrapper}>
              <SavedUser
                user={user}
                onClick={() => {
                  navigate(`/login?user=${user.id}`)
                }}
                onRemove={() => handleRemoveUser(user.id)}
              />
            </div>
          ))}
        </div>
      </div>
    </AuthPageTemplate>
  )
}
